module.exports = __webpack_public_path__ + "static/media/tips2.5f9a4861.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/tips2.png
// module id = 422
// module chunks = 0